/**
 * Relationship Tools Service
 * API calls for relationship-specific content
 */

const API_URL = process.env.REACT_APP_BACKEND_URL;

// ============================================================================
// EMOTIONS API
// ============================================================================

export const getEmotions = async () => {
    const response = await fetch(`${API_URL}/api/relationship/emotions`);
    if (!response.ok) throw new Error('Failed to fetch emotions');
    return response.json();
};

export const getEmotion = async (emotionId) => {
    const response = await fetch(`${API_URL}/api/relationship/emotions/${emotionId}`);
    if (!response.ok) throw new Error(`Failed to fetch emotion: ${emotionId}`);
    return response.json();
};

// ============================================================================
// CYCLE BREAKING SCRIPTS API
// ============================================================================

export const getScripts = async (role = null) => {
    const url = role 
        ? `${API_URL}/api/relationship/scripts/by-role/${role}`
        : `${API_URL}/api/relationship/scripts`;
    const response = await fetch(url);
    if (!response.ok) throw new Error('Failed to fetch scripts');
    return response.json();
};

export const getScriptsByRole = async (role) => {
    const response = await fetch(`${API_URL}/api/relationship/scripts/by-role/${role}`);
    if (!response.ok) throw new Error(`Failed to fetch scripts for role: ${role}`);
    return response.json();
};

// ============================================================================
// CYCLE PATTERNS API
// ============================================================================

export const getCyclePatterns = async () => {
    const response = await fetch(`${API_URL}/api/relationship/cycle-patterns`);
    if (!response.ok) throw new Error('Failed to fetch cycle patterns');
    return response.json();
};

export const getCyclePattern = async (patternId) => {
    const response = await fetch(`${API_URL}/api/relationship/cycle-patterns/${patternId}`);
    if (!response.ok) throw new Error(`Failed to fetch cycle pattern: ${patternId}`);
    return response.json();
};

// ============================================================================
// CYCLE STEPS API (Interactive Visual)
// ============================================================================

export const getCycleSteps = async () => {
    const response = await fetch(`${API_URL}/api/relationship/cycle-steps`);
    if (!response.ok) throw new Error('Failed to fetch cycle steps');
    return response.json();
};

// ============================================================================
// ADHD TRIGGERS API
// ============================================================================

export const getADHDTriggers = async () => {
    const response = await fetch(`${API_URL}/api/relationship/adhd-triggers`);
    if (!response.ok) throw new Error('Failed to fetch ADHD triggers');
    return response.json();
};

export const getADHDTrigger = async (triggerId) => {
    const response = await fetch(`${API_URL}/api/relationship/adhd-triggers/${triggerId}`);
    if (!response.ok) throw new Error(`Failed to fetch ADHD trigger: ${triggerId}`);
    return response.json();
};

// ============================================================================
// HELPFUL INVITATIONS API
// ============================================================================

export const getHelpfulInvitations = async () => {
    const response = await fetch(`${API_URL}/api/relationship/invitations`);
    if (!response.ok) throw new Error('Failed to fetch invitations');
    return response.json();
};

// ============================================================================
// SAFETY CHECK API
// ============================================================================

export const getSafetyQuestions = async () => {
    const response = await fetch(`${API_URL}/api/relationship/safety-questions`);
    if (!response.ok) throw new Error('Failed to fetch safety questions');
    return response.json();
};

export const getSafetyGuidance = async () => {
    const response = await fetch(`${API_URL}/api/relationship/safety-guidance`);
    if (!response.ok) throw new Error('Failed to fetch safety guidance');
    return response.json();
};

// ============================================================================
// CHECK-IN QUESTIONS API
// ============================================================================

export const getCheckinQuestions = async () => {
    const response = await fetch(`${API_URL}/api/relationship/checkin-questions`);
    if (!response.ok) throw new Error('Failed to fetch check-in questions');
    return response.json();
};

// ============================================================================
// SEED ENDPOINT (Admin)
// ============================================================================

export const seedRelationshipTools = async () => {
    const response = await fetch(`${API_URL}/api/relationship/seed`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
    });
    if (!response.ok) throw new Error('Failed to seed relationship tools');
    return response.json();
};

export default {
    getEmotions,
    getEmotion,
    getScripts,
    getScriptsByRole,
    getCyclePatterns,
    getCyclePattern,
    getCycleSteps,
    getADHDTriggers,
    getADHDTrigger,
    getHelpfulInvitations,
    getSafetyQuestions,
    getSafetyGuidance,
    getCheckinQuestions,
    seedRelationshipTools
};
